export default {
  methods: {
    handlePulishShow(skuId, skuCode) {
      skuId instanceof Array ? skuId = skuId : skuId = [skuId];
      skuCode instanceof Array ? skuCode = skuCode : skuCode = [skuCode];
      let tips;
      if(this.spuInfo.productTypeCode == '5'){
        tips = `确认发起“新品上架”流程，下一步等待“产品文案”`
      }else{
        tips = `确认发起“新品上架”流程，下一步等待“拍摄”`
      }
      this.$confirm((<div class="jsx-content">
        {tips}
        <span style="color: #E63946; margin-top: 5px;"></span>
      </div>), '发起上架')
      .then(_=>{
        const loading = this.$loading({
          target: '.app-main',
          lock: true,
        });
        const params = {
          data: skuId
        };
        this.$q.newProduct.submitNewArriaval(params)
          .then(({success}) => {
            if (success) {
              this.$notify.success({
                title: '成功',
                message: '发起上架成功',
              });
              if(skuId.length > 1) {
                this.updateAfterBatchOperation();
              }else{
                this.updateAfterOperation({skuId: skuId[0], skuCode: skuCode[0]});
              }
            }
          })
          .finally(() => {
            loading.close();
          });
      })
      .catch(_=> {});
    },
    publishNow(skuId, skuCode, spuId, tableData = [], isSkipDemand, skuInfo) {
      // debugger
      skuId instanceof Array ? skuId = skuId : skuId = [skuId];
      skuCode instanceof Array ? skuCode = skuCode : skuCode = [skuCode];
      
      // 首批需求，财务定价提示
      let canPublish;
      // 点了订单制按钮后，就不需要首批需求(只需财务定价完整)，即可完成上架
      // if(isSkipDemand == 1) {
      //   canPublish = tableData.every(item => {
      //     return !!item.retailPrice;
      //   });
      // }else{
        // canPublish = tableData.every(item => {
        //   return !!item.demand && !!item.retailPrice;
        // });
      // }
      //不需要在校验财务定价
      if(isSkipDemand == 1) {
        canPublish = true
      }else {
        canPublish = tableData.every(item => {
          return !!item.demand && !item.productCode.includes('DX')
        });
      }

      // 【线下同款】不需要有首批需求和财务定价就可以完成上架
      if(this.spuInfo.productTypeCode != '5') {
        if (!canPublish) {
          this.$alert((<div class="jsx-content">
            产品信息中，“首批需求”还未通过，请先进行完善处理。
            <span style="color: #E63946; margin-top: 5px;">
              
            </span>
          </div>), '完成上线', {
            confirmButtonText: '确定'
          });
          return;
        }
      }
      
      this.$confirm((<div class="jsx-content">
        确认立即上架？
        <span style="color: #E63946; margin-top: 5px;">
          
        </span>
      </div>), '立即上架')
      .then(_=>{
        const loading = this.$loading({
          target: '.app-main',
          lock: true,
        });
        let params = {
          data: []
        };
        skuId.forEach((item, index) => {
          params.data.push({
            skuId: item,
            skuCode: skuCode[index], 
            spuId: spuId
          })
        })
        this.$q.newProduct.publishNow(params)
          .then(({success}) => {
            if (success) {
              this.$notify.success({
                title: '成功',
                message: '立即上架成功',
              });
              this.onPublished();
            }
          })
          .finally(() => {
            loading.close();
          });
      })
      .catch(_=> {});
    },
    skipDemand(skuId, skuCode, spuId, tableData = []) {
      this.$q.newProduct.skipDemand({data: {
        skuCode: skuCode,
        skuId: skuId,
        spuId: spuId
      }})
      .then(({success}) => {
        if (success) {
          this.$notify.success({
            title: '成功',
            message: '已跳过首批量环节',
          });
          this.onPublished();
        }
      })
      .finally(() => {
        loading.close();
      });
    }
  }
}